import React, { Component, useState } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { updateHeaderInfo, getUserDetails } from "../actions";
import { CopyrightWidget, LoadingCard } from "../components";
import { APPVERSION, APPID, createMarkup } from "../common";
import { Divider, Typography, Grid } from "@material-ui/core";
import { deviceData, setContainer } from "../common";
import { isBrowser } from 'react-device-detect';

class CMERedirect extends Component {
    state = {
        appversion: APPVERSION,
        appid: APPID,
        loading: true,
        cme: null,
        year: 1900
    }

    componentDidMount = async () => {
        return this.props.updateHeaderInfo({
            route:"/cmeinfo", 
            name: "SASP", 
            iconTwo: 'menu', 
            iconOne: 'home',
            color: "#00567a"
        });
    };

    render() {
        return (
            <Redirect 
                to={{
                    pathname:'/cmeinfo',
                    state: {
                        cme: this.props.location.cme
                    }
                }}
            />
        )
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details } = state.auth;

    return {
        auth_feedback,
        user_details,
    };
};

const CMERedirectScreen = connect(mapStateToProps, { updateHeaderInfo, getUserDetails })(
    CMERedirect
);

export { CMERedirectScreen };
